/**
 * Global function to handle 401 unauthorized status codes
 * Clears user data and navigates to login page
 */
import { removeAllLocalStorage } from "src/helper/publicFunction";
import { RouterName } from "src/routes/RouterName";

let isNavigating = false;

export const handleUnauthorized = (error) => {
  // Check if status is 401
  const status = error?.response?.status || error?.status;
  // Helpful debug logging to trace where 401 originates
  try {
    // eslint-disable-next-line no-console
    console.log("handleUnauthorized called with error:", {
      message: error?.message,
      status: status,
      url: error?.response?.config?.url,
      method: error?.response?.config?.method,
      responseData: error?.response?.data,
    });
  } catch (e) {
    // ignore logging errors
  }

  if (status === 401) {
    // Check if there's a refresh token available
    const hasRefreshToken = localStorage.getItem("refreshToken");

    // If there's a refresh token, don't force logout - let the refresh logic handle it
    if (hasRefreshToken && !isLoginRequest && !isRefreshRequest) {
      // Let the axios interceptor handle the refresh
      return;
    }

    // Only redirect to login if:
    // 1. It's a login request that failed
    // 2. It's a refresh request that failed (refresh token is invalid)
    // 3. There's no refresh token available
    if (isLoginRequest || isRefreshRequest || !hasRefreshToken) {
      // Clear local storage and redirect to login page
      removeAllLocalStorage();
      localStorage.removeItem("refreshToken"); // Also remove refresh token

      // Prevent multiple redirects
      if (!isNavigating) {
        isNavigating = true;
        // Redirect to login page
        window.location.href = RouterName.auth.login;

        // Reset the flag after a short delay
        setTimeout(() => {
          isNavigating = false;
        }, 1000);
      }
    }

    // For other 401 errors with refresh token, don't redirect immediately - let the refresh logic handle it
    return;
  }
};
